import { render, staticRenderFns } from "./SaveOff.vue?vue&type=template&id=d7522910&scoped=true"
import script from "./SaveOff.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveOff.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SaveOff.vue?vue&type=style&index=0&id=d7522910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7522910",
  null
  
)

export default component.exports